module.exports = __webpack_public_path__ + "static/media/Inkfree.73428cd1.ttf";